import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';

import {
  getPdmApiUrl,
  getAcApiUrl,
  getPurchaseApiUrl,
} from "@tw/shared-ui-components/lib/utils/helper";
import { getAccessHeader } from "@tw/shared-ui-components/lib/utils/loginSession";
import { getLoggedInUserInfo, getVisitorStatus } from "../../utils/helper";
import { ROLE_FOA } from "../../utils/constants";

const SET_HEADER_STATE = "SET_HEADER_STATE";
const SET_FOOTER_STATE = "SET_FOOTER_STATE";
const UPDATE_CART_ITEM_COUNT = "UPDATE_CART_ITEM_COUNT";
const UPDATE_CART_DETAILS = "UPDATE_CART_DETAILS";
const SET_MINI_CART = "SET_MINI_CART";
const SET_CART_COUNT = "SET_CART_COUNT";

export const ac_enums = {
  SET_USER_MENU_STATE: {
    type: "SET_USER_MENU_STATE",
    state: "menuList",
    url: "anon/menus",
  },
  SET_USER_MENU_PARENT_STATE: {
    type: "SET_USER_MENU_PARENT_STATE",
    state: "parents",
    url: "",
  },

  SET_USERINFO: {
    type: "SET_USERINFO",
    state: "userInfo",
    url: "profile/userInfo",
  },
  SET_NAVIGATION_STATE: {
    type: "SET_NAVIGATION_STATE",
    state: "navigation",
    url: "anon/navigation",
  },
};

// COMMON FETCH & SET STATE FUNCTIONS -->
export const setState = (type, state) => {
  return {
    type: type.type,
    payload: state,
  };
};

export const fetchAcState =
  (type = {}) =>
    async (dispatch, getState) => {
      try {
        const apiUrl = getAcApiUrl();
        const loggedInUserData = getLoggedInUserInfo();
        const login = type.url.includes("anon/")
          ? {}
          : getAccessHeader(getState());
        const res = await axios({
          headers: login,
          method: "post",
          url: `${apiUrl}/${type.url}`,
          data: {
            loginAda: loggedInUserData.loginAda,
            distributorType: loggedInUserData.loginType,
          },
        });
        dispatch(setState(type, res.data));
        return res.data;
      } catch (err) {
        console.log(err);
      }
    };

export const fetchCartCount = () => async (dispatch, getState) => {
  try {
    const apiUrl = getPurchaseApiUrl();
    const login = getAccessHeader(getState());
    const loggedInUserData = getLoggedInUserInfo();
    const isVisitor = getVisitorStatus();
    const res = await axios({
      headers: login,
      method: "post",
      url: `/cart/query-summary-cart`,
      data: {
        loginAda: isVisitor ? loggedInUserData.vAda : loggedInUserData.loginAda,
        loginMemberType: isVisitor ? ROLE_FOA : loggedInUserData.role,
        loginType: isVisitor ? "V" : loggedInUserData.loginType,
      },
      baseURL: apiUrl,
    });

    let totalQuantity =
      res && res.data && res.data.totalQuantity ? res.data.totalQuantity : 0;
    dispatch(updateCartItemCount(totalQuantity));

    return totalQuantity;
  } catch (err) {
    console.log(err);
  }
};

// <--

export const setHeaderState = (state) => {
  return {
    type: SET_HEADER_STATE,
    payload: state,
  };
};

export const setFooterState = (state) => {
  return {
    type: SET_FOOTER_STATE,
    payload: state,
  };
};

export const updateCartItemCount = (count) => {
  return {
    type: UPDATE_CART_ITEM_COUNT,
    payload: count,
  };
};

/**
 * *Comments of the parameters of miniCart
 * @param {adaName}  msgcontain the name of the ada user
 * @param {id}  msg contain the id related to order
 * @param {adaNumber}  msg contain the adaNumber of the product
 * @param {products}  msg contain the array of product details and quanity
 * @param {quantity} msg contain the quantity of product added to cart
 */

export const updateCartDetails = (miniCart) => async (dispatch) => {
  await dispatch(fetchCartCount());
  dispatch(setMiniCart(miniCart));
};

export const setMiniCart = (details) => (dispatch) => {
  dispatch({
    type: SET_MINI_CART,
    payload: details,
  });
  setTimeout(
    () =>
      dispatch({
        type: SET_MINI_CART,
        payload: null,
      }),
    3000
  );
};

export const setCartCount = () => {
  return {
    type: SET_CART_COUNT,
    payload: null,
  };
};

export const fetchHFState = () => async (dispatch) => {
  try {
    const FOOTER_LS_KEY = "footer_data";
    // TTL in ms >> sec * 1000 >> min * 60 * 1000
    const TTL = 60 * 60 * 1000;
    const footerDataLS =
      typeof localStorage !== "undefined"
        ? JSON.parse(localStorage.getItem(FOOTER_LS_KEY))
        : null;

    if (footerDataLS && footerDataLS.exp > Date.now()) {
      dispatch(setFooterState(footerDataLS.data));
      return;
    }

    const apiUrl = getPdmApiUrl();
    const res = await axios.post(
      `/footer`,
      {},
      {
        baseURL: apiUrl,
      }
    );
    dispatch(setFooterState(res.data));
    typeof localStorage !== "undefined" &&
      localStorage.setItem(
        FOOTER_LS_KEY,
        JSON.stringify({
          data: res.data,
          exp: Date.now() + TTL,
        })
      );
  } catch (err) { }
};

// Special handle for menu
export const fetchUserMenuState =
  (role = "Guest") =>
    async (dispatch, getState) => {
      console.log("fetchUserMenuState " + role);
      const apiUrl = getAcApiUrl();
      if (role === "") role = "Guest";
      let url = `${apiUrl}/${ac_enums.SET_USER_MENU_STATE.url}/${role}`;

      const res = await axios({
        // headers: getAccessHeader(getState()),
        method: "post",
        url: url,
      });

      dispatch(setState(ac_enums.SET_USER_MENU_STATE, res.data));
      dispatch(setState(ac_enums.SET_USER_MENU_PARENT_STATE, null));
    };

const initialHeaderState = {
  cartItemCount: 0,
  miniCart: null,
};
const headerState = (state = initialHeaderState, action) => {
  switch (action.type) {
    case SET_HEADER_STATE:
      return action.payload;

    case UPDATE_CART_ITEM_COUNT:
      return {
        ...state,
        cartItemCount: action.payload,
      };
    case UPDATE_CART_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    case SET_MINI_CART:
      return {
        ...state,
        miniCart: action.payload,
      };
    case SET_CART_COUNT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

const footerState = (state = {}, action) => {
  switch (action.type) {
    case SET_FOOTER_STATE:
      return action.payload;
    default:
      return state;
  }
};

const userState = (state = {}, action) => {
  switch (action.type) {
    // for special case

    // for use enum
    default:
      if (ac_enums[action.type]) {
        return {
          ...state,
          [ac_enums[action.type].state]: action.payload,
        };
      }

      // for default
      return state;
  }
};

export default {
  headerState,
  footerState,
  userState,
};
